import { useEffect, useState } from "react";
import { Trophy } from "lucide-react";
import { getPremiumYesterday } from "@/services/api";

export function YesterdayPass() {
  const [d, setD] = useState(null);
  useEffect(() => { getPremiumYesterday().then(setD).catch(() => setD({ markets: [] })); }, []);
  if (!d?.markets?.length) return null;
  const date = new Date(d.date).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  return (
    <section data-testid="premium-yesterday-pass" className="rounded-2xl border-2 border-amber-400 bg-gradient-to-br from-amber-50 to-yellow-100 p-4 text-[#3b1d00]">
      <p className="flex flex-wrap items-center gap-2 font-display text-lg font-black">
        <Trophy className="h-5 w-5 text-amber-600" /> Yesterday's Premium Pass ✅
        <span className="text-xs font-bold opacity-70">{date} · {d.markets.length} market</span>
      </p>
      <div className="mt-2 grid gap-1.5 sm:grid-cols-2 lg:grid-cols-3">
        {d.markets.map((m) => (
          <div key={m.name} data-testid="premium-yesterday-row" className="rounded-lg bg-white/70 px-3 py-2 text-xs">
            <p className="font-extrabold">{m.name} <span className="font-mono font-bold text-[color:var(--accent-crimson)]">{m.result}</span></p>
            <div className="mt-1 flex flex-wrap gap-1">
              {m.passes.map((p) => <span key={p} className="rounded bg-emerald-600 px-1.5 py-0.5 font-mono text-[11px] font-bold text-white">{p} ✓</span>)}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
